import * as React from "react";
import { observer } from "mobx-react-lite";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import { TableBodySkeleton } from "../../../components/Skeletons/Tables/TableBody/TableBody";
import { tableStore } from "../../../mobx/stores/TableStore/TableStore";
import { useStyles, StyledTableCell } from "../Tables.styles";
import { TableFooterPagination } from "../TableFooterPagination/TableFooterPagination";
import { ContentMakersProfilesTableRow } from "./ContentMakersProfilesTableRow/ContentMakersProfilesTableRow";

interface ContentMakersProfilesTableProps {
  loading: boolean;
}

export const ContentMakersProfilesTable = observer(({ loading }: ContentMakersProfilesTableProps) => {
  const classes = useStyles();
  const { users, page } = tableStore;
  const { per_page } = page;
  const userInfo = Object.values(users)
    .filter((x) => !x.deleted_at)
    .slice(0, per_page);

  return (
    <Grid item xs={12}>
      <Paper className={classes.paper}>
        <TableContainer component={Paper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell width={20}>Id</StyledTableCell>
                <StyledTableCell>Имя</StyledTableCell>
                <StyledTableCell>Роль</StyledTableCell>
                <StyledTableCell>Дата создания</StyledTableCell>
                <StyledTableCell>Дата Обновления</StyledTableCell>
                <StyledTableCell width={80} />
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBodySkeleton rows={per_page} cols={6} />
            ) : (
              <TableBody>
                {userInfo.map((user) => (
                  <ContentMakersProfilesTableRow user={user} key={user.id} />
                ))}
              </TableBody>
            )}
            <TableFooterPagination colSpan={6} />
          </Table>
        </TableContainer>
      </Paper>
    </Grid>
  );
});
